import { createAsyncThunk, isRejectedWithValue } from "@reduxjs/toolkit";
import { getAttendanceListApi,generateAttendanceApi,getDashboardApi} from "./attendanceApi";
import { toast } from "react-toastify";
import { showApiErrorToast, showApiSuccessToast } from "../../utils/toastErrorHandler";

const handleError = (err,rejectWithValue) => {
    if(err.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
    }
    const errorMessage = err.response?.data?.message || 
    err.response?.data?.data ||
    err.message ||

    "Something went wrong"
    showApiErrorToast(errorMessage)
    return rejectWithValue(err.response?.data || {message: err.message});
};

export const getDashboard = createAsyncThunk(
    "attendance/dashboard",
    async(payload, {rejectWithValue}) => {
        try{
            const response = await getDashboardApi(payload);
            return response.data;
        }catch(err){
            return handleError(err,rejectWithValue)
        }
    }
);

export const getAttendancList = createAsyncThunk(
    "attendance/dashboardList",
    async(payload, {rejectWithValue}) => {
        try{
            const response = await getAttendanceListApi(payload);
            // showApiSuccessToast(response.data.message)
            return response.data;
        }catch(err) {
            return handleError(err,rejectWithValue)
        }
    }
);
export const generateAttendance = createAsyncThunk(
    "attendance/generateAttendance",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await generateAttendanceApi(payload);

            showApiSuccessToast(response.data.message);

            return response.data;
        } catch (err) {
            return handleError(err, rejectWithValue);
        }
    }
);